import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PlantModelElement,
  PlantGroupElement,
} from '../models/O3AdministrationModels/plant-model';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class  EnterPriseGroupService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getGroupList(data: any): Observable<PlantModelElement[]> {
    return this.http.post<PlantModelElement[]>(this.baseUrl + 'PlantModal/GetGroupList', data);
  }
  submitGroup(data: any): Observable<PlantModelElement[]> {
    return this.http.post<PlantModelElement[]>(this.baseUrl + 'PlantModal/SumbitGroup', data);
  }
  getTreeModal(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<PlantGroupElement[]>(this.baseUrl + 'Common_Lean/GetTreeModal', data);
  }
  getTreeModalComponent(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<PlantGroupElement[]>(this.baseUrl + 'CIL/GetCompModelTreeForCIL', data);
  }
  addPlantModalTree(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PlantModal/SumbitChildModel', data);
  }
  getPlantModalById(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'PlantModal/GetChildModel', data);
  }
  GetMenuAccess(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Account/GetMenuAccess', data);
  }
  GetQualityGridAnalysis(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'QualityGradeAnalysis/GetQualityGridAnalysis', data);
  }
  GetQualityGridAnalysisChartData(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'QualityGradeAnalysis/GetQualityGridAnalysisChartData',
      data
    );
  }
  GetQualityJumboTime(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'QualityGradeAnalysis/GetQualityJumboTime', data);
  }
}
